import { Injectable } from '@angular/core';
import { switchMap, tap } from 'rxjs/operators';
import { AuthStoreService } from '../../shared/services/auth/auth-store.service';
import { CustomerStoreService } from './customer-store.service';
import { DialogService } from './dialog.service';
import { Observable } from 'rxjs';
import { AccountStatus, Customer } from '../models/customer.model';
import { ContentDataService } from '../../liabilities/services/content-data.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  constructor(
    private customerStoreService: CustomerStoreService,
    private dialogService: DialogService,
    private authStoreService: AuthStoreService,
    private contentStoreService: ContentDataService,
    private apiService: ApiService,
  ) {
  }

  /**
   * Upgrading user if it is possible.
   */
  public upgradeAccountStatus() {
    return this.customerStoreService.upgradeAccountStatus();
  }

  public updateNick(nick: string): Observable<any> {
    return this.customerStoreService.updateNick(nick);
  }

  public updateIban(iban: string): Observable<any> {
    return this.customerStoreService.updateIban(iban);
  }

  public getActiveAgreementsCount() {
    return this.customerStoreService.state.paykaFinancialData ?
      (this.customerStoreService.state.paykaFinancialData?.activeAgreementsCount) : 0;
  }

  public getRequiredPayments() {
    return this.customerStoreService.state.paykaFinancialData ?
      this.customerStoreService.state.paykaFinancialData?.toPayMonth : 0;
  }

  public getRequiredOverduePayments() {
    return this.customerStoreService.state.paykaFinancialData ?
      this.customerStoreService.state.paykaFinancialData.toPayOverdue : 0;
  }

  public getUsedLimit() {
    return this.customerStoreService.state.paykaFinancialData ?
      this.customerStoreService.state.paykaFinancialData.limitNettoUsed : 0;
  }

  public isMedium() {
    return this.customerStoreService.state.accountStatus === AccountStatus.MEDIUM;
  }

  public deleteAccount() {
    return this.customerStoreService.deleteAccount()
      .pipe(
        switchMap(() => this.authStoreService.logout(true)),
        tap(() => this.contentStoreService.clear()),
      );
  }

  public refresh(): Observable<Customer> {
    return this.customerStoreService.loadCustomer(this.customerStoreService.state.customerId);
  }

  public saveOpenNotificationDate() {
    return this.apiService.post(`/customers/${this.authStoreService.userInfo.customer_id}/notifications/open`);
  }
}
